document.body.classList.add("js");

import "../styles/main.scss";
import "swiper/css";
import "swiper/css/effect-fade";
import "./patterns/tabs-advanced.js";
import 'sharer.js';
import './salesforce-ninja.js';
import './forms.js';
//import './pardot-forms.js';

import GLightbox from "glightbox";

import {isInViewport} from '@roghz/isinviewport';

import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(SplitText, ScrollTrigger);


const videoSelector = ".video-lightbox, a[href*='youtube.com']:not([target='_blank']), a[href*='youtu.be']:not([target='_blank']), a[href*='vimeo.com']:not([target='_blank']), a[href$='.mp4']:not([target='_blank']), a[href$='.webm']:not([target='_blank']), a[href$='.ogg']:not([target='_blank'])";
document.querySelectorAll(videoSelector).forEach(link => {
    link.classList.add('is-video');
});

const lightboxVideo = GLightbox({
    selector: videoSelector,
    autoplayVideos: true,
});

document.addEventListener('DOMContentLoaded', () => {


    const elements = document.querySelectorAll('.count-animation');
    elements?.forEach(el => {
        el.innerHTML = el.innerHTML.replace(/(\d+)/, '<span class="count-value">$1</span>');
        el.dataset.target = el.querySelector('.count-value').textContent;
        el.dataset.animated = 'false';
    });
    const animateElement = el => {
        if (el.dataset.animated === 'true') return;
        el.dataset.animated = 'true';
        const target = parseInt(el.dataset.target, 10);
        const span = el.querySelector('.count-value');
        const duration = 2000;
        const startTime = performance.now();
        const animate = currentTime => {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            span.textContent = Math.floor(progress * target);
            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                span.textContent = target;
            }
        };
        requestAnimationFrame(animate);
    };
    const checkElements = () => {
        elements.forEach(el => {
            if (isInViewport(el)) animateElement(el);
        });
    };
    window.addEventListener('scroll', checkElements);
    window.addEventListener('resize', checkElements);
    checkElements();

    // ANIMATED HEADINGS

    document.querySelectorAll(".words-animation").forEach((element) => {
        const split = new SplitText(element, { type: "words" });
        const words = split.words;
        if (!words.length) return;

        gsap.set(words, { opacity: 0.2 });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: "top bottom",
                end: "top 25%",
                scrub: true,
            }
        });

        tl.to(words, {
            opacity: 1,
            duration: 0.1,
            stagger: 1 / words.length
        });
    });

    // SHARE:


    document.querySelectorAll('.social-share').forEach(link => {
        link.addEventListener('click', function (e) {
            if (typeof navigator !== "undefined" && navigator.share) {
                e.preventDefault();
                navigator.share({
                    title: document.title,
                    url: window.location.href,
                });
            }
        });
    });


    document.querySelectorAll('.share-copy-link').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const url = this.getAttribute('data-link');
            if (!url) return;
            navigator.clipboard.writeText(url).then(() => {
                this.classList.add('active');
                setTimeout(() => this.classList.remove('active'), 2000);
            });
        });
    });

});

const blocks = import.meta.glob("../../blocks-fintua/**/script.js", { eager: true });
